import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '../pages/Login.tsx';
import Dashboard from '../pages/Dashboard.tsx';
import ReportDetail from '../pages/ReportDetail.tsx';
import ReportCreate from '../pages/ReportCreate.tsx';
import ProtectedRoute from '../components/ProtectedRoute.tsx';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Login />} />
    <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
    <Route path="/report/:id" element={<ProtectedRoute><ReportDetail /></ProtectedRoute>} />
    <Route path="/report/create" element={<ProtectedRoute><ReportCreate /></ProtectedRoute>} />
    <Route path="/report/create/:id" element={<ProtectedRoute><ReportCreate /></ProtectedRoute>} />
  </Routes>
);

export default AppRoutes;
